import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();
  return {
    grid: {
      display: 'grid',

      gridTemplateColumns: 'auto 1fr auto',
      gridTemplateRows: 'auto',
      gridTemplateAreas: `
      "tabs addNew actionsMenu"
    `,
      width: '100%',
    },
    tabsArea: {
      gridArea: 'tabs',
      alignSelf: 'end',
    },
    addNewArea: {
      gridArea: 'addNew',
      alignSelf: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    actionsMenuArea: {
      gridArea: 'actionsMenu',
      backgroundColor: '#fff',
      display: 'flex',
      alignItems: 'center',
    },
    tabs: {
      '& .MuiTabs-flexContainer': {
        position: 'relative',
        zIndex: 10,
      },
      '& .MuiTabScrollButton-root.Mui-disabled': {
        opacity: 0.15,
      },
    },
    tabIndicator: {
      backgroundColor: '#fff',
      height: 'calc(100% - 4px)',
      borderTop: `solid 3px ${theme.palette.primary.main}`,
      borderRadius: theme.spacing(0.5, 0.5, 0, 0),
      zIndex: 1,
    },
    tab: {
      minHeight: '48px',
      '& .workspace-type-icon': {
        color: theme.palette.primary.main,
      },
      '&.Mui-selected .workspace-type-icon': {
        color: theme.palette.text.primary,
      },
    },
  };
};
